import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ErrorUiComponent } from '@pool-league/frontend-shared-ui-common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lib-not-found',
  imports: [ErrorUiComponent, RouterLink],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {}
